// Vorbelegung der Kontaktanlage im Zuweisen-Dialog (PO 28.09.2026: „wenn nicht
// gefunden in der Suche, Text übernehmen in der Anlage").
//
// Rein und ohne React, damit die Zerlegung direkt testbar ist.

export type NamensVorbelegung = { vorname: string; nachname: string; firmenname: string };

/**
 * Aus dem Suchtext (oder, ohne Suche, dem Ordnernamen der alten Akte) die
 * Namensfelder machen. Die Ordner heißen meist „Nachname, Vorname" — so wie
 * KMVS Namen auch sonst schreibt; ohne Komma ist das letzte Wort der Nachname.
 * Die Firma bekommt den Text unverändert.
 */
export const namenAusSuchtext = (text: string): NamensVorbelegung => {
  const t = text.replace(/\s+/g, " ").trim();
  if (!t) return { vorname: "", nachname: "", firmenname: "" };
  const komma = t.indexOf(",");
  if (komma >= 0) {
    return {
      nachname: t.slice(0, komma).trim(),
      vorname: t.slice(komma + 1).trim(),
      firmenname: t,
    };
  }
  const worte = t.split(" ");
  if (worte.length === 1) return { vorname: "", nachname: t, firmenname: t };
  return { vorname: worte.slice(0, -1).join(" "), nachname: worte[worte.length - 1], firmenname: t };
};

/**
 * Der POST-Body für /contact — dieselben Felder wie die Schnellanlage aus der
 * Mail (`mailContactAssign.buildPrivatPayload`/`buildFirmaPayload`), nur mit
 * dem vollen Status aus `statusFuerApi` statt der drei festen Werte.
 */
export const kontaktPayload = (args: {
  typ: "person" | "firma";
  vorname: string;
  nachname: string;
  firmenname: string;
  rechtsform: { legalForm: string; id?: string };
  statusName: string;
  weitereStatus: string[];
  typeId: number | null;
  ownership: Record<string, unknown>;
}): Record<string, unknown> => {
  const status = {
    statusName: args.statusName,
    ...(args.weitereStatus.length ? { weitereStatus: args.weitereStatus } : {}),
  };
  if (args.typ === "firma") {
    const name = args.firmenname.trim();
    const form = args.rechtsform.legalForm.trim();
    const id = Number(args.rechtsform.id);
    return {
      lastname: name,
      displayName: name,
      type: args.typeId != null ? { id: args.typeId, type: "Firma" } : { id: 1, type: "Firma" },
      ...(form ? { legalForm: Number.isInteger(id) && id > 0 ? { id, legalForm: form } : form } : {}),
      ...status,
      ...args.ownership,
    };
  }
  const nachname = args.nachname.trim();
  const vorname = args.vorname.trim();
  return {
    lastname: nachname,
    displayName: vorname ? `${nachname}, ${vorname}` : nachname,
    ...(vorname ? { firstName: vorname } : {}),
    ...(args.typeId != null ? { type: { id: args.typeId } } : {}),
    ...status,
    ...args.ownership,
  };
};
